// extracted by mini-css-extract-plugin
export default {"center":"center---PxKfW","left":"left---TCVVV","right":"right---p_lE0"};